export default "__VITE_ASSET__b3dfe66b__"